import { FC, useCallback, useEffect, useState } from "react";
import {
  useGetBase64StringLazyQuery,
} from "../generated/graphql";
import { useResizeObserver } from "@wojtekmaj/react-hooks";
import { pdfjs, Document, Page } from "react-pdf";
import type { PDFDocumentProxy } from "pdfjs-dist";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { CandidateDetails } from "../generated/graphql";
interface DocumentPreviewProps {
  candidateDetails: CandidateDetails;
  addToDownload(): any;
}

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const options = {
  cMapUrl: "/cmaps",
  standardFontDataUrl: "/standard_fonts",
};

const resizeObserverOptions = {};
const maxWidth = 800;

const DocumentPreview: FC<DocumentPreviewProps> = ({
  candidateDetails,
  addToDownload,
}) => {
  const [resumeHTML, setResumeHTML] = useState<string>("");
  const [numPages, setNumPages] = useState<number>();
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);
  const [containerWidth, setContainerWidth] = useState<number>();
  const [loading, setLoading] = useState(false);
  const [getBase64StringQuery, { data: base64StringData, loading: base64StringLoading, error: base64StringError }] = useGetBase64StringLazyQuery();
  const onResize = useCallback<ResizeObserverCallback>((entries) => {
    const [entry] = entries;
    if (entry) {
      setContainerWidth(entry.contentRect.width);
    }
  }, []);

  function onDocumentLoadSuccess({
    numPages: nextNumPages,
  }: PDFDocumentProxy): void {
    setNumPages(nextNumPages);
  }

  const handleDownload = () => {
    setLoading(true);
    if (candidateDetails.url) {
      addToDownload();
      window.open(candidateDetails.url as string, '_blank');
    }
    setLoading(false);
  };


  useResizeObserver(containerRef, resizeObserverOptions, onResize);
  useEffect(() => {
    if (candidateDetails.file_name && !candidateDetails.file_name.includes(".doc")) {
      // if URL exists, then get base64 string from URL and set it to base64String with mime type
      console.log("candidateDetails.url", candidateDetails.url);
      if (candidateDetails.url) {
        getBase64StringQuery({ variables: { url: candidateDetails.url as string } });
      }
    } else {
      // DOC FILE
      if (candidateDetails.url) {
        setResumeHTML(candidateDetails.url as string);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateDetails.url, candidateDetails.file_name]);
  return (
    <>
      <Box className="flex justify-between mt-2">
        <Typography variant="h5">Resume</Typography>
        <Button
          onClick={handleDownload}
          sx={{ bgcolor: "#ffffff", marginBottom: "10px" }}
          disabled={loading}
        >
          Download Resume
        </Button>
      </Box>
      {!candidateDetails.file_name?.includes(".doc") && !base64StringLoading && !base64StringError && base64StringData?.getBase64String ? (
        <div className="">
          <Document
            file={base64StringData.getBase64String as string}
            onLoadSuccess={onDocumentLoadSuccess}
            options={options}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={
                  containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth
                }
              />
            ))}
          </Document>
        </div>
      ) : (
        <>
          <div className="p-3 bg-common-white rounded-md">
            {resumeHTML.split("\n").map((line: string) => {
              return (
                <>
                  <p>{line}</p>
                </>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export default DocumentPreview;
